export const AcademicCalendarActions = {
    GET_ACADEMIC_CALENDAR: "GET_ACADEMIC_CALENDAR",
    SET_ACADEMIC_CALENDAR: "SET_ACADEMIC_CALENDAR",
  };
     